export default __webpack_public_path__ + "images/MuestrasRegistradasBesafer 4.0-FR.png";